export default "__VITE_ASSET__pQK36SMN__"